import React from 'react';

import { Box, Typography } from '@mui/material';

export default function WorkspaceNotes() {
  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 3 }}>
      <Box sx={{ maxWidth: '65ch' }}>
        <Typography variant="subtitle2" gutterBottom>
          Hotel ownership
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Country and commercial contact come from the available hotel records. The commercial contact is not a verified
          account manager; territory assignments are not connected yet.
        </Typography>
      </Box>
      <Box sx={{ maxWidth: '65ch' }}>
        <Typography variant="subtitle2" gutterBottom>
          Features still to connect
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Close Loss, room-level connection checks and Salesforce parity work are not available in this view.
        </Typography>
      </Box>
    </Box>
  );
}
